import React from "react";

export default function Banner({ image, bottomComponent }) {
  return (
    <div style={{ height: "25rem" }} className="w-100 position-relative">
      <img
        src={image}
        alt="Model"
        className="rounded"
        style={{
          height: "100%",
          objectFit: "cover",
          width: "100%",
          objectPosition: "top",
        }}
      />
      <div
        className="position-absolute w-100 h-100 rounded"
        style={{
          top: 0,
          backgroundImage:
            "linear-gradient(to bottom, transparent, rgba(0, 0, 0, .2), rgba(0, 0, 0, 1) )",
        }}
      />
      <div
        className="position-absolute fw-semibold"
        style={{ bottom: "1rem", left: "1rem", fontSize: "1rem" }}
      >
        {bottomComponent}
      </div>
    </div>
  );
}
